<template>
  <v-dialog v-model="pinDialog" persistent max-width="450">
    <v-card>
      <CardToolbar title="Change Pin" :isModal="true" @cancel="close" />
      <v-divider></v-divider>
      <v-card-text class="mt-5">
          <v-layout column justify-center align-center class="my-1">
            <v-flex shrink>
              <v-row>
                <v-col v-for="circle in pinCodeCircles" :key="circle">
                  <v-icon x-large :color="pinColor(circle)">{{ pinCodeStyle(circle) }}</v-icon>
                </v-col>
              </v-row>
            </v-flex>
            <v-col class="mt-5">
              <v-row justify="center" fill-height style="height: 100%">
                <v-col
                  v-for="num in numbers"
                  :key="num"
                  class="col-4 text-center"
                >
                  <v-btn fab height="80" @pointerdown.stop.prevent="pointerMode && selectedNum(num)"
                    @click.stop.prevent="!pointerMode && selectedNum(num)" width="80" color="primary">
                    <span class="text-h3">{{ num }}</span>
                  </v-btn>
                </v-col>
                <v-col class="col-8 text-center">
                    <v-btn height="80" block rounded @pointerdown.stop.prevent="pointerMode && selectedNum(0)"
                      @click.stop.prevent="!pointerMode && selectedNum(0)" color="primary">
                      <span class="text-h3">0</span>
                    </v-btn>
                  </v-col>
                  <v-col class="col-4 text-center">
                    <v-btn height="80" block rounded  @pointerdown.stop.prevent="pointerMode && clearPin()"
                      @click.stop.prevent="!pointerMode && clearPin()" color="red" dark>
                      <span class="text-h3">C</span>
                    </v-btn>
                  </v-col>
              </v-row>
            </v-col>
          </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog"],
  data: () => ({
    pinDialog: false,
    pinCodeCircles: [1, 2, 3, 4],
    pin: "",
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    pointerMode: "PointerEvent" in window,
  }),
  watch: {
    dialog(val){
      this.pinDialog = val
    },
    pin() {
      // Reseting Pin
      if (this.pin.length === 5) {
        this.pin = "";
      }

      // Submiting
      if (this.pin.length === 4) {
        this.pinSubmit(this.pin);
      }
    },
  },
  methods: {
    pinColor(num) {
      if (this.pin.length >= num) {
        return "secondary";
      }
      else {
        return "grey";
      }
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) {
        return "mdi-check-circle";
      }
      else {
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    selectedNum(num) {
      num = num.toString();
      this.pin = this.pin.concat(num).trim();
    },
    pinSubmit(val) {
      this.pin = val;
      this.$emit('submit', this.pin)
      this.clearPin();
    },
    clearPin() {
      this.pin = ""
    },
    close(){
      this.pin = "",
      this.$emit('close')
    }
  },
}
</script>